export const CUSTOMER_PORTAL_W2_SECTIONS = Object.freeze([
  Object.freeze({
    id: 'orders-billing',
    title: 'Orders and billing',
    description: 'Orders, payment status, invoices, and receipts will appear only from accepted Commerce projections.',
    state: 'CONTRACT_HELD',
    earliestAvailability: 'Commerce Phase 6 and Website W3',
    gateIds: Object.freeze(['W0-ID-01', 'W0-PAY-01', 'W0-FIN-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'agreements',
    title: 'Agreements',
    description: 'Agreement versions, signatures, and signed PDFs remain with the current primary until one Commerce writer is accepted.',
    state: 'CONTRACT_HELD',
    earliestAvailability: 'Commerce Phase 6B',
    gateIds: Object.freeze(['W0-FIN-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'files',
    title: 'Files and paperwork',
    description: 'Purchased ZIP packages, PDFs, and DOCX files require an accepted Content grant and protected delivery contract.',
    state: 'CONTRACT_HELD',
    earliestAvailability: 'Content Phase 8 and Website W4',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CONT-01', 'W0-ENT-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'academy',
    title: 'MI Academy',
    description: 'Courses, recordings, webinars, schedules, progress, and certificates require accepted Content and entitlement projections.',
    state: 'CONTRACT_HELD',
    earliestAvailability: 'Content Phase 8 and Website W4',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CONT-01', 'W0-ENT-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'company-tms',
    title: 'Company and TMS access',
    description: 'Company trials, editable paperwork, Office Suite, and TMS launch require effective permissions—not payment status alone.',
    state: 'CONTRACT_HELD',
    earliestAvailability: 'TMS Phases 7–10 and Website W4',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CAT-01', 'W0-PAY-01', 'W0-CONT-01', 'W0-ENT-01', 'W0-LAUNCH-01', 'W0-TRIAL-01', 'W0-SVC-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'communications-support',
    title: 'Communications and support',
    description: 'Marketing preferences, required transactional notices, and support tickets need one governed website writer and audit policy.',
    state: 'CONTRACT_HELD',
    earliestAvailability: 'Website governance decision',
    gateIds: Object.freeze(['W0-ID-01', 'W0-COMMS-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'legacy-claim',
    title: 'Previous purchase claim',
    description: 'Older purchases cannot be attached by matching email. A verified, reviewable legacy-ownership claim is reserved for W5.',
    state: 'CONTRACT_HELD',
    earliestAvailability: 'Website W5',
    gateIds: Object.freeze(['W0-ID-01', 'W0-ID-02', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
]);
